import { useContext } from 'react';

import ModeChangeContext from '../../store/mode-change-context';
import microsoft from '../../assets/microsoft.png';
import nit from '../../assets/NITJ-logo.png';
import WorkCard from './WorkCard';
import TrophyAnimation from './TrophyAnimation';
import styles from './PastWork.module.css'

const Achievements = () => {

    const modeCtx = useContext(ModeChangeContext);


    const styleLight = {
        background: 'rgb(255,255,255)',
        color: '#000'
    }

    const styleDark = {
        background: 'rgb(14,19,31)',
        color: '#fff'
    }

    return (
        <div className={styles.section} style={!modeCtx.mode ? styleLight : styleDark}>
            <div className={styles.animation}>
                <h1 className={styles.heading}>Achievements & Certifications</h1>
                <div><TrophyAnimation /></div>
            </div>
            <div className={styles.list}>
                <WorkCard src={nit} alt={'Placement Representative'} heading={'Placement Representative'} position={'NIT Jalandhar'} detail1={'2023-24'} achievement />
                <WorkCard src={microsoft} alt={'Microsoft Engage 2022'} heading={'Microsoft Engage 2022'} position={'Mentee'} achievement button link1={'https://github.com/vanshitadev10/Microsoft-Engage2022-Face-Recognition-App'} btn1='Have A Look At Project' />
                <WorkCard heading={'Certificates & Badges'} position={'Please click on the button below to view my certificates & Badges'} achievement button link1={'https://drive.google.com/drive/folders/1KL_HZC0vAVTWmi5PrHXJNlkmAs1nUPwO?usp=sharing'} link2={'https://www.credly.com/users/vanshita-dev.d207358'} btn1='Certificates' btn2='Credly Badges' />
            </div>
        </div>
    );

};

export default Achievements;